import gsap from 'gsap';

export default class TagsListing extends HTMLElement {
    static CALL_EVENT = 'callTagsListing';
    static INTERVALLE = 3;
    static NUM_ITEMS_TO_ACTIVATE = 5; // Number of items to activate

    constructor() {
        super();

        /* Binding */
        this.onScrollCall = this.onScrollCall.bind(this);
        this.onUpdate = this.onUpdate.bind(this);

        /* UI */
        this.$items = Array.from(this.querySelectorAll('[data-item]'));

        /* Data */
        this.uid = this.dataset.uid;
        this.activeIndexes = new Set();
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.bindEvents();
    }

    disconnectedCallback() {
        this.unbindEvents();
        this.delayedCall?.kill();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        window.addEventListener(`${TagsListing.CALL_EVENT}${this.uid}`, this.onScrollCall);
    }

    unbindEvents() {
        window.removeEventListener(`${TagsListing.CALL_EVENT}${this.uid}`, this.onScrollCall);
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onScrollCall(event) {
        // Handle scroll enter/leave events for autoplay
        const { way } = event.detail;

        switch (way) {
            case 'enter':
                this.play();
                break;
            case 'leave':
                this.pause();
                break;
        }
    }

    onUpdate() {
        // If there is only one word, stop the animation
        if (this.$items.length <= TagsListing.NUM_ITEMS_TO_ACTIVATE) {
            this.delayedCall?.kill();
            return;
        }

        // Disable all active items
        this.activeIndexes.forEach((index) => {
            this.$items[index].classList.remove('is-active');
        });
        this.activeIndexes.clear();

        // Generate new unique random indexes
        while (this.activeIndexes.size < TagsListing.NUM_ITEMS_TO_ACTIVATE) {
            const randomIndex = Math.floor(Math.random() * this.$items.length);
            this.activeIndexes.add(randomIndex);
        }

        // Activate new items
        this.activeIndexes.forEach((index) => {
            this.$items[index].classList.add('is-active');
        });

        // Restart the animation
        this.delayedCall.restart(true);
    }

    // =============================================================================
    // Methods
    // =============================================================================
    play() {
        if (this.isPlaying) return;
        this.delayedCall = gsap.delayedCall(TagsListing.INTERVALLE, this.onUpdate, null);
        this.isPlaying = true;
    }

    pause() {
        if (!this.isPlaying) return;
        this.delayedCall?.kill();
        this.isPlaying = false;
    }
}
